enum ProdIntercomArticlesIds {
  BuyerRolesAndPermissions = 11645645,
  SupplierRolesAndPermissions = 11645758,
  Commissions = 9425028,
  ExemptFromIngredientList = 13699285
}

enum StagingIntercomArticlesIds {
  BuyerRolesAndPermissions = 11645651,
  SupplierRolesAndPermissions = 11645763,
  Commissions = 11645653,
  ExemptFromIngredientList = 13699347
}

export const IntercomArticlesIds = import.meta.env.PROD ? ProdIntercomArticlesIds : StagingIntercomArticlesIds;
